module.exports = __webpack_public_path__ + "img/money-icon.3015b242.png";